import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/home";

export default function FeaturedArticles() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              深度解读亚洲好物背后的故事与匠心
            </p>
          </div>
          <Link
            to="/articles"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap no-underline cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {article.date}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="text-xs text-foreground-500">
                  {article.readTime}阅读
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}